import { ShipmentSummary, FreightCostInput, FreightCostResult, FreightMode, ShipmentInput, Accessorial } from '@freight-cbm/shared-types';
import { calcShipmentSummary } from './summary';

export function calcFreightCost(
  summary: ShipmentSummary,
  costInput: FreightCostInput,
  mode: FreightMode,
): FreightCostResult {
  let baseCost = 0;
  let rateUsed = 0;
  let chargeableUnit = '';
  let chargeableAmount = 0;

  switch (mode) {
    case FreightMode.Air:
    case FreightMode.Courier:
      chargeableAmount = summary.chargeableWeightKg;
      rateUsed = costInput.ratePerKg;
      baseCost = chargeableAmount * rateUsed;
      chargeableUnit = 'kg';
      break;
    case FreightMode.OceanLCL: {
      const revenueTon = Math.max(summary.totalCBM, summary.grossWeightKg / 1000);
      chargeableAmount = revenueTon;
      rateUsed = costInput.ratePerRevenueTon > 0 ? costInput.ratePerRevenueTon : costInput.ratePerCBM;
      baseCost = chargeableAmount * rateUsed;
      chargeableUnit = costInput.ratePerRevenueTon > 0 ? 'revenue ton' : 'CBM';
      break;
    }
  }

  const accessorialCost = costInput.accessorials.reduce((sum, a) => sum + a.cost, 0);
  const totalCost = baseCost + accessorialCost;

  return {
    baseCost,
    accessorialCost,
    totalCost,
    currency: costInput.currency,
    rateUsed,
    chargeableUnit,
    chargeableAmount,
  };
}

export function calcFCLCost(
  containerCount: number,
  ratePerContainer: number,
  accessorials: Accessorial[],
  currency: string,
): FreightCostResult {
  const baseCost = containerCount * ratePerContainer;
  const accessorialCost = accessorials.reduce((sum, a) => sum + a.cost, 0);
  const totalCost = baseCost + accessorialCost;

  return {
    baseCost,
    accessorialCost,
    totalCost,
    currency,
    rateUsed: ratePerContainer,
    chargeableUnit: 'container',
    chargeableAmount: containerCount,
  };
}

export function calcAirVsOceanComparison(
  shipment: ShipmentInput,
  airRatePerKg: number,
  oceanRatePerCBM: number,
  currency: string = 'USD',
): { airCost: FreightCostResult; oceanCost: FreightCostResult; savings: number } {
  const summary = calcShipmentSummary(shipment);

  const airCost = calcFreightCost(summary, {
    ratePerKg: airRatePerKg,
    ratePerCBM: 0,
    ratePerRevenueTon: 0,
    ratePerContainer: 0,
    accessorials: [],
    currency,
  }, FreightMode.Air);

  const oceanCost = calcFreightCost(summary, {
    ratePerKg: 0,
    ratePerCBM: oceanRatePerCBM,
    ratePerRevenueTon: 0,
    ratePerContainer: 0,
    accessorials: [],
    currency,
  }, FreightMode.OceanLCL);

  return {
    airCost,
    oceanCost,
    savings: Math.abs(airCost.totalCost - oceanCost.totalCost),
  };
}
